import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated. Please log in.");
      navigate("/admin/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-8 flex justify-center">
          <img src="/kk-logo.png" alt="KK Beauty & Fashion" className="h-12 w-auto max-w-full" />
        </Link>
        <div className="border border-zinc-200 bg-white p-8">
          <h1 className="font-display text-lg">Set New Password</h1>
          <form onSubmit={submit} className="mt-6 space-y-5">
            <div>
              <Label className="text-xs uppercase tracking-wider text-zinc-500">Reset Token</Label>
              <Input value={token} onChange={(e) => setToken(e.target.value)} className="mt-1.5 rounded-none border-zinc-300" required data-testid="reset-token" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-zinc-500">New Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 rounded-none border-zinc-300" required minLength={6} data-testid="reset-password" />
            </div>
            {error && <p className="text-sm text-kksale">{error}</p>}
            <Button type="submit" disabled={loading} className="h-11 w-full rounded-none bg-zinc-900 text-xs uppercase tracking-widest" data-testid="reset-submit">
              {loading ? "Updating…" : "Update Password"}
            </Button>
          </form>
          <Link to="/admin/login" className="mt-4 block text-center text-xs text-zinc-500 hover:text-zinc-900">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
